import { StatusChip as RawStatusChip } from 'components/Chips/StatusChip'
import { StatusChipProps } from './type'
import { chipColors } from './utils/chipColors'

export const StatusChip = ({ status }: StatusChipProps): JSX.Element => (
  <RawStatusChip {...{ chipColors, status }} />
)
